var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.414 13.696c-.663-.583-1.467-1.086-2.39-1.496a.781.781 0 1 0-.634 1.428c.778.346 1.448.763 1.992 1.241a3.115 3.115 0 0 1 1.055 2.342v1.445c0 .431-.35.782-.78.782H3.343a.782.782 0 0 1-.781-.782v-1.445c0-.899.384-1.752 1.055-2.342.79-.693 3.089-2.306 7.382-2.306a5.788 5.788 0 0 0 5.781-5.782A5.788 5.788 0 0 0 11 1a5.788 5.788 0 0 0-5.781 5.781c0 1.864.886 3.524 2.26 4.582-2.513.552-4.076 1.615-4.893 2.333A4.678 4.678 0 0 0 1 17.21v1.445A2.346 2.346 0 0 0 3.344 21h15.312A2.346 2.346 0 0 0 21 18.656v-1.445c0-1.348-.578-2.63-1.586-3.515Z",
    stroke: "#FFF",
    strokeWidth: 0.2,
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.781 6.781A4.224 4.224 0 0 1 11 2.563a4.224 4.224 0 0 1 4.219 4.218A4.224 4.224 0 0 1 11 11a4.224 4.224 0 0 1-4.219-4.219Z",
    fill: "#FFF"
  }))));
};
export default SvgProfile;